import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PurchaseDetailCreateRequestDTO, PurchaseDetailDeleteRequestDTO, PurchaseDetailDTO, PurchaseDetailList, PurchaseDetailReadByIdRequestDTO, PurchaseDetailReadByInvoiceIdForImportRequestDTO, PurchaseDetailReadByInvoiceIdRequestDTO, PurchaseDetailReadByItemIdRequestDTO, PurchaseDetailUpdateRequestDTO, PurchaseDetailUpsertBulkRequestDTO } from './purchase-detail.interface';
import { Observable } from 'rxjs';
import { PurchaseDetail_Create, PurchaseDetail_Update, PurchaseDetail_Delete, PurchaseDetail_ReadAll, PurchaseDetail_ReadById, PurchaseDetail_ReadByInvoiceId, PurchaseDetail_ReadByItemId, PurchaseDetail_ReadByInvoiceIdForImport, PurchaseDetail_UpsertBulk } from 'src/app/GlobalVariables';


@Injectable({
  providedIn: 'root'
})
export class PurchaseDetailService {

  constructor() { }

  http = inject(HttpClient);

  PurchaseDetail_Create(data: PurchaseDetailCreateRequestDTO): Observable<PurchaseDetailDTO> {
    return this.http.post<PurchaseDetailDTO>(PurchaseDetail_Create, data);

  }

  PurchaseDetail_Update(data: PurchaseDetailUpdateRequestDTO): Observable<PurchaseDetailDTO> {
    return this.http.post<PurchaseDetailDTO>(PurchaseDetail_Update, data);
  }

  PurchaseDetail_Delete(data: PurchaseDetailDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PurchaseDetail_Delete, data);
  }

  PurchaseDetail_ReadAll(): Observable<PurchaseDetailList> {
    return this.http.get<PurchaseDetailList>(PurchaseDetail_ReadAll);
  }

  PurchaseDetail_ReadById(data: PurchaseDetailReadByIdRequestDTO): Observable<PurchaseDetailDTO> {
    return this.http.post<PurchaseDetailDTO>(PurchaseDetail_ReadById, data);
  }

  PurchaseDetail_ReadByInvoiceId(data: PurchaseDetailReadByInvoiceIdRequestDTO): Observable<PurchaseDetailList> {
    return this.http.post<PurchaseDetailList>(PurchaseDetail_ReadByInvoiceId, data);
  }

  PurchaseDetail_ReadByItemId(data: PurchaseDetailReadByItemIdRequestDTO): Observable<PurchaseDetailList> {
    return this.http.post<PurchaseDetailList>(PurchaseDetail_ReadByItemId, data);
  }

  PurchaseDetail_ReadByInvoiceIdForImport(data: PurchaseDetailReadByInvoiceIdForImportRequestDTO): Observable<PurchaseDetailList> {
    return this.http.post<PurchaseDetailList>(PurchaseDetail_ReadByInvoiceIdForImport, data);
  }

  PurchaseDetail_UpsertBulk(data: PurchaseDetailUpsertBulkRequestDTO): Observable<PurchaseDetailList> {
    return this.http.post<PurchaseDetailList>(PurchaseDetail_UpsertBulk, data);
  }

}
